import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import StorageService, { STORAGE_KEYS } from '../utils/storage.util';
import { decodeAccessToken, decodeIdToken, decodeMetadataToken } from '../utils/token.utils';

// A mock authentication function
export const isAuthenticated = () => {
    try {
        const accessToken = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
        if(!accessToken) return false;
        const decodedAccessToken = decodeAccessToken();
        if(!decodedAccessToken || (decodedAccessToken.exp * 1000) < Date.now() ) return false;
        return true
    } catch (error) {
        return false;
    }
};

const ProtectedRoute = ({ children } : any) => {
    const navigate = useNavigate();
    
    useEffect(() => {
        if (!isAuthenticated()) {
            navigate('/logout', { replace: true });
            return;
        }
    }, [navigate]);
    
    return children;
};

export default ProtectedRoute;